var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.element)?_c('v-row',{staticClass:"mb-3",attrs:{"no-gutters":"","justify":"center"}},[_c('v-textarea',{staticClass:"mb-2",attrs:{"label":"Frage eingeben...","rows":"2","outlined":"","hide-details":"","dense":""},model:{value:(_vm.element.text),callback:function ($$v) {_vm.$set(_vm.element, "text", $$v)},expression:"element.text"}}),_c('CompSurveySlider',{staticStyle:{"width":"100%"},attrs:{"text":_vm.element.text,"compSettings":`{
      "preset": ${_vm.element.preset},
      "min": ${_vm.element.min},
      "max": ${_vm.element.max},
      "label1": "${_vm.element.leftLabel}",
      "label2": "${_vm.element.rightLabel}",
      "questionId": 1
    }`},on:{"changed:slider":_vm.onChanged}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }